import React from 'react';
import {
  KycElement,
  useWallet,
  Verifications,
  Wallet,
  WhopElements,
  type KycElementCreateOptions,
  type KycElementProps,
  type VerificationsOptions,
  type WalletOptions,
  type WhopElementsProps,
} from '@whop/elements-react';

/**
 * Whop Elements React components return ReactNode, which React 18 JSX typing rejects.
 * These adapters restore valid JSX component types for CRA's TypeScript build.
 */
export const WhopElementsProvider = WhopElements as React.FC<WhopElementsProps>;
export const WhopVerifications = Verifications as React.FC<
  VerificationsOptions & { children?: React.ReactNode; fallback?: React.ReactNode }
>;
export const WhopWallet = Wallet as React.FC<WalletOptions & { children?: React.ReactNode }>;
export const WhopKycElement = KycElement as React.FC<KycElementProps & KycElementCreateOptions>;
export { useWallet };
